import React from "react";
import CustomSvg from "../custom-svg/CustomSvg";
import {
  PaginationFirst,
  PaginationLast,
  PaginationNext,
  PaginationPrev,
} from "../../../assets";

const TablePagination = (props) => {
  const {
    currentPage = 0, // zero-based index
    totalItems = 0,
    pageSize = 0,
    onPageChange = () => {},
    onPageSizeChange = () => {},
  } = props.paginationData ?? {};

  const totalPages = Math.ceil(totalItems / pageSize);
  const startItem = currentPage * pageSize + 1;
  const endItem = Math.min((currentPage + 1) * pageSize, totalItems);

  return (
    <div className="pagination-container">
      <div className="d-flex flex-wrap column-gap-4 row-gap-2 justify-content-center justify-content-md-start align-items-center">
        <div>
          <button
            onClick={() => onPageChange(0)}
            disabled={currentPage === 0}
            className="pagination-button"
          >
            <CustomSvg src={PaginationFirst} />
          </button>
          <button
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 0}
            className="pagination-button"
          >
            <CustomSvg src={PaginationPrev} />
          </button>
          <span className="pagination-info">{` ${currentPage + 1} `}</span>
          <button
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage + 1 === totalPages}
            className="pagination-button"
          >
            <CustomSvg src={PaginationNext} />
          </button>
          <button
            onClick={() => onPageChange(totalPages - 1)}
            disabled={currentPage + 1 === totalPages}
            className="pagination-button"
          >
            <CustomSvg src={PaginationLast} />
          </button>
        </div>
        <div className="d-flex gap-3 align-items-center">
          <span className="pagination-text">
            {`Showing ${startItem} to ${endItem} of ${totalItems}`}
          </span>
          <select
            value={pageSize}
            onChange={(e) => {
              onPageSizeChange(Number(e.target.value));
            }}
            className="page-size-selector"
          >
            {[10, 20, 30, 50].map((size) => (
              <option key={size} value={size}>
                Show {size}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default TablePagination;
